var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qdt-wrapper"},[_c('p',[_vm._v("QdtComponent")]),_c('p',[_vm._v("Name: "+_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }